// extracted by mini-css-extract-plugin
module.exports = {"groupWrapper":"InputsGroup_groupWrapper__Sp_nV","isOnDark":"InputsGroup_isOnDark__ur5Ga","group":"InputsGroup_group__71vcs","errorMessage":"InputsGroup_errorMessage__3zbxF"};